module.exports = __webpack_public_path__ + "static/img/crm-swiper-2.ebd6b7d3.png";